import { getOpxHostApi, isOpx } from 'owa-opx';
import { PopoutMessageType, postMessage } from 'owa-popout-v2/lib/utils/crossWindowMessenger';

export function onCloseDeeplinkCompose() {
    if (isOpx()) {
        getOpxHostApi()
            .then(opxAdaptor => {
                opxAdaptor.onOwaTaskCompleted();
            })
            .catch(e => {
                // We do nothing if this errors, at least for now.
            });
    } else {
        if (window.opener) {
            // We try to send a post message for OWA scenarios and scenarios that listen to this
            postMessage(window.opener, PopoutMessageType.CloseWindow);
        }
        // Else, we try to close the window manually for non OPX. This sometimes doesn't work, so we do it last just for completeness.
        try {
            window.close();
        } catch {
            // We don't actually care if this throws an exception, as we handle it elsewhere.
        }
    }
}
